import { isNotEmpty, toJSON } from '@rehaje/shared'

import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaURLSearchParamsSpecific } from '../../types'

export class SchemaURLSearchParamsDefinition extends SchemaDefinition {
  override defaultsMerge(value: any, schema: SchemaURLSearchParamsSpecific) {
    return value ?? this.getDefaults(schema)
  }

  getDefaults(schema: SchemaURLSearchParamsSpecific): any | undefined {
    return new Function(
      `return new URLSearchParams(${JSON.stringify(toJSON(schema.entries) ?? [])})`
    )()
  }

  override getIn(schema: SchemaURLSearchParamsSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaURLSearchParamsSpecific,
    path: PropertyKey[]
  ): SchemaURLSearchParamsSpecific {
    if (
      !(target instanceof URLSearchParams) ||
      !this.test(target, schema, path)
    ) {
      return { ...schema, type: 'Schema.URLSearchParams' }
    }
    return {
      ...schema,
      entries: Array.from(target.entries()),
      type: 'Schema.URLSearchParams'
    }
  }

  override inferOnlySchema(schema: SchemaURLSearchParamsSpecific) {
    return schema
  }

  override inferTypeScript(): string {
    return `URLSearchParams`
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaURLSearchParamsSpecific,
    path: PropertyKey[]
  ) {
    if (target === null && schema.nullable) return target
    if (!this.test(target, schema, path)) return this.getDefaults(schema)
    return target
  }

  override validate(target: any, schema: SchemaURLSearchParamsSpecific): void {
    this.validateMetadata(
      target,
      schema,
      (value) => value instanceof URLSearchParams,
      isNotEmpty
    )
  }
}
